import React from "react";
import PropTypes from "prop-types";
import testimonialsData from "./staffTestimonials.data";
import peerTestimonials from "./peerTestimonials.data";
import { handleImageError } from "../../utils/imageUtils";
import './Testimonials.module.css';

const TestimonialsSection = () => (
  <section className="card" aria-label="Testimonials section">
    <div className="text-center">
      {testimonialsData.map((testimonial, index) => (
        <article key={index} className="card">
          <div className="testimonials-layout__image">
            {testimonial.image ? (
              <img
                src={testimonial.image}
                className="image--circular"
                alt={testimonial.name || `Testimonial ${index + 1}`}
                onError={(e) => handleImageError(e)}
                loading="lazy"
              />
            ) : (
              testimonial.images?.map((imgSrc, imgIndex) => (
                <img
                  key={imgIndex}
                  src={imgSrc}
                  className="image--circular"
                  alt={`Contributor ${imgIndex + 1}`}
                  onError={(e) => handleImageError(e)}
                  loading="lazy"
                />
              ))
            )}
          </div>
          <div className="testimonials-layout__content">
            <blockquote>
              <p>
                {testimonial.text}
                {testimonial.name && (
                  <cite>
                    <h6>
                      {testimonial.name}, {testimonial.title}
                    </h6>
                  </cite>
                )}
                {testimonial.names?.map((person, personIndex) => (
                  <cite key={personIndex}>
                    <h6>
                      {person.name}, {person.title}
                    </h6>
                  </cite>
                ))}
              </p>
            </blockquote>
          </div>
        </article>
      ))}

      {peerTestimonials.map((peer, index) => (
        <article key={`peer-${index}`} className="card">
          <div className="testimonials-layout__content">
            <blockquote>
              <p>
                {peer.text}
                <cite>
                  <h6>
                    {peer.name}, {peer.title}
                  </h6>
                </cite>
              </p>
            </blockquote>
          </div>
        </article>
      ))}
    </div>
  </section>
);

TestimonialsSection.propTypes = {};

export default TestimonialsSection;
